import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Loader2, ZoomIn, ZoomOut } from "lucide-react";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

export const PdfViewer = ({ data }) => {
  const [pages, setPages] = useState(0);
  const [scale, setScale] = useState(1.15);
  const [error, setError] = useState(null);

  return (
    <div className="flex h-full flex-col" data-testid="pdf-viewer">
      <div className="flex items-center justify-between border-b border-navy/10 bg-white px-4 py-2 text-xs text-slate-600">
        <span data-testid="pdf-viewer-pages">{pages ? `${pages} pagin${pages === 1 ? "a" : "e"}` : "Caricamento..."}</span>
        <div className="flex items-center gap-1">
          <button onClick={() => setScale((s) => Math.max(0.6, s - 0.15))} className="p-1.5 hover:text-navy" aria-label="Riduci" data-testid="pdf-zoom-out"><ZoomOut className="h-4 w-4" /></button>
          <span className="w-12 text-center font-semibold text-navy">{Math.round(scale * 100)}%</span>
          <button onClick={() => setScale((s) => Math.min(2.5, s + 0.15))} className="p-1.5 hover:text-navy" aria-label="Ingrandisci" data-testid="pdf-zoom-in"><ZoomIn className="h-4 w-4" /></button>
        </div>
      </div>
      <div className="flex-1 overflow-auto bg-slate-200 p-4">
        {error ? (
          <p className="py-10 text-center text-sm text-red-600" data-testid="pdf-viewer-error">{error}</p>
        ) : (
          <Document
            file={data}
            onLoadSuccess={({ numPages }) => setPages(numPages)}
            onLoadError={() => setError("Impossibile visualizzare il PDF. Scarica il file per aprirlo.")}
            loading={<div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-navy" /></div>}
            className="flex flex-col items-center gap-4"
          >
            {Array.from({ length: pages }, (_, i) => (
              <Page key={i} pageNumber={i + 1} scale={scale} className="shadow-lg" renderAnnotationLayer={false} data-testid={`pdf-page-${i + 1}`} />
            ))}
          </Document>
        )}
      </div>
    </div>
  );
};
